// database/client.ts
import Dexie, { type EntityTable } from 'dexie';
import { schemas, DB_NAME } from './schemas';
import { Metric, MetricLog, MediaMetricLog } from './types';

class MatinsDatabase extends Dexie {
  metrics!: EntityTable<Metric, 'id'>;
  metricLogs!: EntityTable<MetricLog, 'id'>;
  mediaMetricLogs!: EntityTable<MediaMetricLog, 'id'>;

  constructor() {
    super(DB_NAME);

    Object.entries(schemas).forEach(([version, schema]) => {
      this.version(Number(version)).stores(schema);
    });
  }
}

export const db = new MatinsDatabase();
